import type { StateCreator } from "zustand";
import type { UploadAnswerPayload } from "@/repositories/evaluation/types-core";

export interface PendingAnswer extends UploadAnswerPayload {
  timestamp: number;
  retryCount: number;
}

export interface PendingAnswersSliceState {
  pendingAnswers: PendingAnswer[];
  addPendingAnswer: (payload: UploadAnswerPayload) => void;
  removePendingAnswer: (timestamp: number) => void;
  updatePendingAnswer: (timestamp: number, updates: Partial<PendingAnswer>) => void;
  clearPendingAnswers: () => void;
}

export const createPendingAnswersSlice: StateCreator<
  PendingAnswersSliceState,
  [],
  [],
  PendingAnswersSliceState
> = (set, _get) => ({
  pendingAnswers: [],
  addPendingAnswer: (payload) => {
    const newPendingAnswer: PendingAnswer = {
      ...payload,
      timestamp: Date.now(),
      retryCount: 0,
    };
    set((state) => ({
      pendingAnswers: [...state.pendingAnswers, newPendingAnswer],
    }));
  },
  removePendingAnswer: (timestamp) =>
    set((state) => ({
      pendingAnswers: state.pendingAnswers.filter((answer) => answer.timestamp !== timestamp),
    })),
  updatePendingAnswer: (timestamp, updates) =>
    set((state) => ({
      pendingAnswers: state.pendingAnswers.map((answer) =>
        answer.timestamp === timestamp ? { ...answer, ...updates } : answer
      ),
    })),
  clearPendingAnswers: () => set({ pendingAnswers: [] }),
});
